import React from 'react';
import times from 'lodash/times';
import { Box } from '../../../../../../../CommonComponents/OPL/Box/Box';
import { Shimmer } from '../../../../../../../CommonComponents/OPL/Shimmer/Shimmer';

export const EntitySearchResultsLoading = () => {
  return (
    <Box>
      {times(6).map(key => (
        <Shimmer key={key} height={24} width="100%" mb="8" />
      ))}
    </Box>
  );
};
